import { gql } from '@apollo/client'

export const GLOBAL_SEARCH_QUERY = gql`
  query GLOBAL_SEARCH_QUERY($filter: GlobalSearchFilterInput!, $pagination: PaginationInput!) {
    globalSearch(filter: $filter, pagination: $pagination) {
      pagination {
        pageSkip
        pageTake
        totalCount
      }
      plans {
        id
        companyId
        name
        parentPlanId
      }
      planKPIs {
        id
        description
        planItems {
          data {
            id
            referenced
            planKPIId
            path
            plan {
              id
              name
            }
          }
        }
        destinationLinkingItems {
          id
        }
        sourceLinkingItems {
          id
        }
      }
      planActions {
        id
        description
        planItems {
          data {
            id
            referenced
            planActionId
            path
            plan {
              id
              name
            }
          }
        }
        destinationLinkingItems {
          id
        }
        sourceLinkingItems {
          id
        }
      }
      planObjectives {
        id
        description
        planItems {
          data {
            id
            referenced
            planObjectiveId
            path
            plan {
              id
              name
            }
          }
        }
        destinationLinkingItems {
          id
        }
        sourceLinkingItems {
          id
        }
      }
    }
  }
`
